import { useLocation } from '@tanstack/react-router'
// eslint-disable-next-line no-restricted-imports
import queryString from 'query-string'

/**
 * A custom hook that builds on useLocation to parse
 * the query string.
 *
 * @returns {object} Object with search query params
 *
 * @example
 * const { step } = useSearchParams()
 */

export default function useSearchParams() {
  return queryString.parse(useLocation({ select: (l) => l.searchStr }))
}
